import React, { useContext } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Box,
  Button,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  DrawerCloseButton,
  useDisclosure,
  WrapItem,
  Wrap,
  Flex,
  VStack,
} from "@chakra-ui/react";
import CreateWallet from "./CreateWalletArb";
import TenetBox from "./TenetBox";
import GmxPositions from "../gmx/GmxPositions";
import { AppContext } from "../../AppContext";

const PositionsSection = ({
  totalCollateral,
  totalPositions,
  handleTotalCollateralChange,
  handleTotalPositionsChange,
  currentPrice,
  updateTotalBalance,
  handleActiveBalanceUpdate,
  activeBalance,
  tradeSettings,
  fetchPrice,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { fastestWebSocket, contractAddress } = useContext(AppContext);

  return (
    <>
<Wrap w="100%" h="100%" bg="gray.400">
              <WrapItem w="100%" minWidth="300px" justify="center">
                <VStack w="100%" justify="center">
                  <TenetBox
                    totalCollateral={totalCollateral}
                    totalPositions={totalPositions}
                    activeBalance={activeBalance}
                  />
                </VStack>
              </WrapItem>

              <WrapItem w="100%">
                <GmxPositions
                  fastestWebSocket={fastestWebSocket}
                  onTotalCollateralChange={handleTotalCollateralChange}
                  onTotalPositionChange={handleTotalPositionsChange}
                  contractAddress={contractAddress}
                  currentPrice={currentPrice}
                  fetchPrice={fetchPrice}
                  tradeSettings={tradeSettings}
                  activeBalance={activeBalance}
                  handleActiveBalanceUpdate={handleActiveBalanceUpdate}
                />
              </WrapItem>
            </Wrap>


      {/* Right Sliding Drawer for DeployedWallets */}
      <Drawer isOpen={isOpen} placement="right" onClose={onClose} bg="gray.50">
        <DrawerOverlay />
        <DrawerContent bg="gray.200">
          <DrawerCloseButton />

          <DrawerBody p={1} mt={3}>
            {/**<DeployedWallets /> */}
            <CreateWallet />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default PositionsSection;
